<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card color="white" elevation="0" style="border-radius: 20px !important">
      <v-card-title class="warning-color" style="border-radius: 20px !important">
        التبويبات
        <v-spacer></v-spacer>
        <v-text-field rounded v-model="search" outlined append-icon="mdi-magnify" label="بحث" single-line hide-details></v-text-field>
        <div style="width: 20px"></div>
        <AddExpensesType @reloadTask="initialData()" :doctors="doctors" :users="employees" :doctorMaterials="doctorMaterials" />
      </v-card-title>
      <v-data-table :headers="headers" :items="ItemsFilter" :items-per-page="15" class="table-content table-warning-color">
        <template v-slot:[`item.index`]="{ index }">
          <h4 style="padding: 0 3px">{{ index + 1 }}</h4>
        </template>

        <template v-slot:[`item.amount`]="{ item }">
          <h4 style="padding: 0 3px">
            {{
              item.amount.toLocaleString("en-US", {
                style: "currency",
                currency: "IQD",
              })
            }}
          </h4>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <DeleteExpensesType @reloadTask="initialData" :dataToDelete="item" v-if="$store.state.userData.roleId == 1" />
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import AddExpensesType from "./expensesTypes/AddExpensesType.vue";
import DeleteExpensesType from "./expensesTypes/DeleteExpensesType.vue";
export default {
  components: {
    AddExpensesType,
    DeleteExpensesType,
  },
  data: () => ({
    overlay: false,
    search: "",
    expensesTypes: [],
    doctors: [],
    headers: [
      { text: "العدد", value: "index" },
      { text: "التبويب", value: "typeName" },
      { text: "الاجراءات", value: "actions" },
    ],
    employees: [],
    doctorMaterials: [],
  }),
  created() {
    this.initialData();
  },
  methods: {
    initialData() {
      let self = this;
      self.overlay = true;
      self.$http
        .all([
          self.$http.get(`${self.$store.state.apiUrl}/expensesTypes`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
        ])
        .then(
          self.$http.spread((expensesTypes) => {
            self.expensesTypes = expensesTypes.data;
            console.log(expensesTypes.data);
            self.overlay = false;
          })
        )
        .catch((error) => {
          self.overlay = false;
          console.log(error);
        });
    },
  },
  computed: {
    ItemsFilter() {
      if (this.search) {
        return this.expensesTypes.filter((item) => {
          return this.search
            .toLowerCase()
            .split(" ")
            .every((v) => item.patientName.toLowerCase().includes(v));
        });
      } else {
        return this.expensesTypes;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
